import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { RouteComponentProps } from 'react-router'
import { Menu, Skeleton } from 'antd'
import { FormComponent, BaseFormComponentProps } from '../../BaseComponent'
import IAdoptionApplication from '../../../interfaces/IAdoptionApplication'
import { SearchRequest, AdoptionApplicationCheckoutUpdateRequest, AdoptionApplicationCheckoutRemoveProductRequest } from '../../../services/api/interfaces/ApiRequest'

// Tabs
import Information from './Information'
import Checkout from './Checkout'

export type AdoptionApplicationProps = RouteComponentProps & BaseFormComponentProps & {
  uuid: string,
  data: IAdoptionApplication | null,
  loading?: boolean,
  error: any | null,

  loadAdoptionApplication: (args: SearchRequest) => void,
  adoptionApplicationCheckoutUpdate: (args: AdoptionApplicationCheckoutUpdateRequest) => void,
  adoptionApplicationCheckoutRemoveProduct: (args: AdoptionApplicationCheckoutRemoveProductRequest) => void,
}

interface MenuTab {
  name: string,
  path: string,
  component: React.ComponentClass<AdoptionApplicationProps>
}

class AdoptionApplication extends FormComponent<AdoptionApplicationProps> {

  state = {
    loaded: false
  }

  menuTabs: MenuTab[] = [
    {
      name: 'Information',
      path: 'information',
      component: Information
    },
    {
      name: 'Checkout',
      path: 'checkout',
      component: Checkout
    }
  ]

  componentDidMount() {
    const { uuid, loading, loadAdoptionApplication } = this.props

    if (!loading) {
      loadAdoptionApplication({
        search: {
          uuid,
          checkout: {
            with: {
              deleted: false
            }
          },
          payment_charge: {
            with: {
              deleted: false
            }
          },
          adopter_user: {
            with: true
          },
          pet: {
            with: {
              specie: {
                with: true
              },
              branch: {
                with: {
                  shelter: {
                    with: true
                  }
                }
              }
            }
          }
        }
      })
    }
  }

  componentDidUpdate(prevProps: AdoptionApplicationProps, prevState) {
    if (!prevProps.data && this.props.data) {
      this.setState({
        loaded: true
      })
    }
  }

  render() {
    const { uuid, match: { params: { activeTab } } }: any = this.props
    const { loaded } = this.state

    if (!loaded) {
      return <Skeleton />
    }

    const currentTab = this.menuTabs.find(tab => tab.path === activeTab) || this.menuTabs[0]
    const selectedKeys = [`tab-${currentTab.path}`]

    return (
      <div>
        <Menu selectedKeys={selectedKeys} mode="horizontal">
          {
            this.menuTabs.map(tab => (
              <Menu.Item key={`tab-${tab.path}`}>
                <Link to={`/organization/adoption-application/${uuid}/${tab.path}`}>{tab.name}</Link>
              </Menu.Item>
            ))
          }
        </Menu>

        <div style={{marginTop: 20}}>
          {<currentTab.component {...this.props} />}
        </div>
      </div>
    )
  }
}

export default withRouter(AdoptionApplication)
